export default __webpack_public_path__ + "static/media/spaceship.86ecff28.png";